import { Mail, MessageSquare, Shield } from "lucide-react";
import { useTitle } from "@/lib/brand";
import { PageHead } from "@/components/Kit";

/**
 * CONTACT — rebuilt 2026-10-27. Still no form on purpose (08-28: a form needs an endpoint, a spam
 * gate and a store — three things that break quietly; a mailto cannot). The addresses are the ones
 * the old page and the Privacy page already published.
 */
export default function ContactPage() {
  useTitle("Contact");
  const rows = [
    { icon: Mail, h: "Support and general questions", v: "ipexpertsfactory@gmail.com", href: "mailto:ipexpertsfactory@gmail.com" },
    { icon: Shield, h: "Privacy and data requests", v: "expertsllc@proton.me", href: "mailto:expertsllc@proton.me" },
    { icon: MessageSquare, h: "Android testing community", v: "Join the open testing thread", href: "https://www.reddit.com/r/AndroidAppTesters/s/O4sWHmz7RG", ext: true },
  ];
  return (
    <main data-testid="contact-page" className="ex-page">
      <div className="ex-narrow pb-28">
        <PageHead eyebrow="Contact" title="Talk to us." lede="Every message is read and answered by a person, not a bot — usually within one business day." />
        <div className="space-y-3">
          {rows.map(({ icon: Icon, h, v, href, ext }) => (
            <a key={h} href={href} {...(ext ? { target: "_blank", rel: "noopener noreferrer" } : {})} className="ex-card ex-card-link flex items-center gap-5 p-6">
              <span className="inline-flex h-11 w-11 flex-none items-center justify-center rounded-xl bg-[color:var(--ex-user)]">
                <Icon className="h-5 w-5 text-white" strokeWidth={1.7} />
              </span>
              <span className="min-w-0">
                <span className="block ex-small">{h}</span>
                <span className="block text-white text-[16px] mt-0.5 break-all">{v}</span>
              </span>
            </a>
          ))}
        </div>
        <p className="ex-small mt-10">IP Experts LLC, doing business as Experts.</p>
      </div>
    </main>
  );
}
